{{#each this}}
<div class="photo-card">
<a class="photo-card_linc" href={{this.largeImageURL}}>
  <img src={{this.webformatURL}} alt={{this.tags}} loading="lazy" class="photo-card_Img"/>
 </a>
  <div class="info">
    <p class="info-item">
      <b>Likes</b><br>{{this.likes}}
    </p>
    <p class="info-item">
      <b>Views</b><br>{{this.views}}
    </p>
    <p class="info-item">
      <b>Comments</b><br>{{this.comments}}
    </p>
    <p class="info-item">
      <b>Downloads</b><br>{{this.downloads}}
    </p>
  </div>
</div>
{{/each}}